import {Grid} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useQuery} from "react-query";
import {Notifier} from "../../../components";
import BlockWard from "../../../components/BlockWard";
import DeleteDialog from "../../../components/Dialog/DeleteDialog";
import {INotifierProps} from "../../../components/Notifier/Notifier";
import PrescriptionBlock from "../../../components/PrescriptionItens/PrescriptionBlock";
import PrescriptionListWard from "../../../components/PrescriptionItens/PrescriptionListWard";
import {GlobalContext} from "../../../contexts";
import usePrescriptions from "../../../services/usePrescription";

function Prescriptions() {
    const [notifier, setNotifier] = useState<INotifierProps>(null);
    const {view} = useContext(GlobalContext);
    const [page, setPage] = useState(1);
    const {getPrescriptionsPage, deletePrescription, getPrescriptions} = usePrescriptions()
    const [openDelete, setOpenDelete] = React.useState<{ open: boolean, valueToDelete: any }>({
        open: false,
        valueToDelete: null
    });

    const currents = useQuery(['01', page], getPrescriptionsPage, {
        refetchInterval: 60000,
    })

    // const currents = getUnits

    function handleCloseDelete(): void {
        setOpenDelete({open: false, valueToDelete: null});
    }

    function handlePaginator(page: number) {
        setPage(page)
    }

    function handleDelete() {
        deletePrescription(openDelete.valueToDelete).then(
            () => setNotifier({open: true, severity: 'success', msg: 'Cadastro deletado com sucesso!'}),
            () => setNotifier({open: true, severity: 'error', msg: 'Erro ao deletar cadastro.'}),
        );
        handleCloseDelete();
    }

    useEffect(() => {
        currents.refetch();
    }, [page])

    if (currents.isSuccess && currents?.data?.data?.length) {
        if (view === "block")
            return (
                <Grid
                    container
                    gap={2}
                    padding={view === "block" ? "20px" : ""}
                    sx={{
                        overflowY: "auto",
                    }}
                >
                    <>

                        <BlockWard title="Unidades" _id="unidades">
                            {currents.data.data.map((item) => {
                                return (
                                    <PrescriptionBlock data={item} key={item._id}/>
                                )
                            })}
                        </BlockWard>
                    </>
                </Grid>
            );
        else return <>
            <Notifier
                msg={notifier?.msg}
                closeState={setNotifier}
                severity={notifier?.severity}
                open={notifier?.open}
                closeTime={notifier?.closeTime}
            />
            <PrescriptionListWard isPageable={true} setDelete={setOpenDelete} limit={currents.data.limit}
                           total={currents.data.total} handlePaginator={handlePaginator} data={currents.data.data}/>;
            <DeleteDialog open={openDelete.open} handleClose={handleCloseDelete} onConfirmDelete={handleDelete}
                          name="deleteDialog"></DeleteDialog>
        </>
    }
    return null;
}

export default Prescriptions;